var blockquote_default = {
  "fontElementMap": "LucOA",
  "quote": "YbjSb"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
